// extracted by mini-css-extract-plugin
export default {"text":"vaPVfAx6MGrM8CL1uVCxMA==","buttonAction":"lWLllgh5TOgfqoUoD8258g=="};